var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube-tab",class:{'cube-tab_active': _vm.isActive},on:{"click":_vm.handleClick}},[_vm._t("icon",[_c('i',{class:_vm.icon})]),_vm._v(" "),_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }